import LandingFAQ from './LandingFAQ';

export default LandingFAQ;
export { type LandingFAQProps } from './LandingFAQ';
